var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",class:[("icon--" + _vm.name), ("icon--" + _vm.size), { 'has-align-fix': _vm.fixAlign }]},[_c('font-awesome-icon',{staticClass:"font-awesome-icon",attrs:{"icon":_vm.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }